// Define the Splide configuration object
const splideConfig = {
  perPage: 4,
  focus  : 0,
  omitEnd: true,
  perMove: 1,
  gap: '32px',
  pagination: false, 
  arrows: false,     
  drag: false,      
  breakpoints: {
    1920: {
      perPage: 4,
      perMove: 1,
      gap: '32px',
      padding: { right: '0px' },
    },
    1120: {
      perPage: 2,
      perMove: 1,
      start  : 0,
      gap: '32px',
      padding: { right: '12.4rem' },
    },
    767: {
      perPage: 1,
      perMove: 1,
      gap: '20px',
      padding: { right: '20%' },
    },
    430: {
      perPage: 1,
      perMove: 1,
      gap: '20px',
      padding: { right: '30%' },
    },
  },
};

function initSplide() {
  const el = document.querySelector('#best-sellers-hover');
  
  if (!el) return;

  if (el.classList.contains('is-initialized')) return;

  const splide = new Splide(el, splideConfig);
  
  splide.on('overflow', function(isOverflow) {
      // Only update if the state actually changes to avoid unnecessary refreshes
      const currentPagination = splide.options.pagination;
      
      if (currentPagination !== isOverflow) {
          const options = {
              pagination: isOverflow,
              drag: isOverflow
          };
          
          splide.options = {...splide.options, ...options};
      }
  });
  
  splide.mount();
}

// Add event listeners
document.addEventListener('DOMContentLoaded', initSplide);
document.addEventListener('shopify:section:load', initSplide);